import Reveal from './Reveal.jsx'
import { events } from '../data/events.jsx'

export default function Events() {
  return (
    <section className="events" id="events">
      <div className="container">
        <div className="section-head">
          <Reveal as="p" className="eyebrow center">What We Curate</Reveal>
          <Reveal as="h2" className="section-title center" delay={60}>Occasions We Bring to Life</Reveal>
          <Reveal as="p" className="section-sub center" delay={120}>
            From regal weddings to refined corporate affairs, each event is
            designed as a singular experience, tailored end-to-end by our in-house team.
          </Reveal>
        </div>

        <div className="events-grid">
          {events.map((event, i) => (
            <Reveal as="article" className="event-card" delay={(i % 3) * 60} key={event.title}>
              <span className="event-num">{event.num}</span>
              <span className="event-icon" aria-hidden="true">{event.icon}</span>
              <h3>{event.title}</h3>
              <p>{event.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
